import {sendPostRequest, sendPutRequest} from '../requests';
import {encodeQueryData} from '../helpers';

const loginUrl = '/login';
const activeUrl = '/tenants/active';
const logoutUrl = '/logout';

type ActiveTenantProps = {
  tenant: string
}

export const getUserPermissions = () => sendPostRequest(loginUrl);

export const logoutUser = () => sendPostRequest(logoutUrl);

export const updateActiveTenant = (data: ActiveTenantProps) => {
  const requestUrl = activeUrl + encodeQueryData(data);

  return sendPutRequest(requestUrl);
};
